import React, { useState } from 'react';
import { TextInput, Typography } from '@vp/swan';
import PropTypes from 'prop-types';

export const DebugNewFeatureEntry = ({ overrideNewFeature }) => {
  const [newFeatureName, setNewFeatureName] = useState('');

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      overrideNewFeature({ featureName: newFeatureName });
      setNewFeatureName('');
    }
  };

  const handleTextInput = event => {
    const newFeatureNameInput = event.target.value.trim();
    if (newFeatureNameInput !== newFeatureName) {
      setNewFeatureName(newFeatureNameInput);
    }
  };

  return (
    <>
      <Typography fontWeight="bold" fontSize="small" mb={3}>
        Enter New Feature:
      </Typography>
      <TextInput
        size="mini"
        label="Enter a new feature to introduce in this session, enabled by default."
        onChange={handleTextInput}
        onKeyPress={handleKeyPress}
        value={newFeatureName}
      />
    </>
  );
};

DebugNewFeatureEntry.propTypes = {
  overrideNewFeature: PropTypes.func.isRequired,
};
